import initialState from 'flux/initialState/router.initialState';
import { router as actions } from 'flux/actions';
import { connectRouter, LOCATION_CHANGE } from 'connected-react-router';

const router = (state, action) => {
  const { types } = actions;

  switch (action.type) {
    case types.UPDATE_QUERY: {
      const { query } = action.payload;
      return {
        ...state,
        query: {
          ...state.query,
          ...query,
        },
      };
    }
    case types.UPDATE_GEOLOCATION: {
      const { geolocation } = action.payload;
      return {
        ...state,
        geolocation,
      };
    }
    case types.SET_GCLID_DEPENDENCIES_READY: {
      return {
        ...state,
        gclidDependenciesReady: true,
      };
    }
    // case types.SET_STORE_ID_READING_READY: {
    //   return {
    //     ...state,
    //     storeIdReadingReady: true,
    //   };
    // }

    default:
      return state;
  }
};

export default function (history) {
  const connectedRouterReducer = connectRouter(history);

  // append `previousLocation` value to connected-react-router LOCATION_CHANGE reducer
  const enrichedReducer = (state, action) => {
    let currentState = state;
    if (action.type === LOCATION_CHANGE) {
      currentState = action.payload.isFirstRendering
        ? { ...state, ...initialState }
        : { ...state, previousLocation: state.location };
    }
    return connectedRouterReducer(currentState, action);
  };

  return (state, action) => {
    const reducedState = enrichedReducer(state, action);
    return router(reducedState, action);
  };
}
